<template>
    <button type="button" :class="`focus:bg-${buttonColor}-800 active:bg-${buttonColor}-700 bg-${buttonColor}-700 hover:bg-${buttonColor}-800`" class="flex px-6 py-2 text-white font-medium text-xs leading-tight rounded shadow-lg hover:shadow-lg  focus:shadow-lg focus:outline-none focus:ring-0  active:shadow-lg transition duration-150 ease-in-out justify-center">
        <svg v-if="onSubmit" class="animate-spin h-4 w-4 mr-2" viewBox="0 0 24 24"><path fill="currentColor" d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z" /></svg>
        <span class="text-sm">{{ submitButtonText }}</span> 
    </button>
</template>

<script setup>
import { computed } from 'vue'
    let props = defineProps({
        onSubmit: {
            type: Boolean,
            default: () =>false
        },
        buttonText:{
            type: String,
            required: true
        },
        buttonColor:{
            type: String,
            required: true
        }
    })

    let submitButtonText = computed(() => {
        return props.onSubmit ? 'Please Wait' : props.buttonText
    })

</script>
